export default __webpack_public_path__ + "static/media/lightning.0488b423.svg";